import DapDSTextarea from './textarea.component'

export * from './textarea.component'
export default DapDSTextarea

DapDSTextarea.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-textarea': DapDSTextarea
  }
}
